module.exports={render:function (){with(this) {
  return _h('tbody', {
    attrs: {
      "id": "id"
    }
  }, [(summary) && _l((summary), function(s) {
    return _h('tr', [_h('td', {
      staticClass: "empty",
      attrs: {
        "colspan": "5"
      }
    }, [_h('button', {
      on: {
        "click": newProduct
      }
    }, ["Dodaj"])]), " ", _h('th', {
      staticClass: "number"
    }, [_s(s.vat)]), " ", _h('td', {
      staticClass: "number"
    }, [_s(money(s.nettoValue))]), " ", _h('td', {
      staticClass: "number"
    }, [_s(money(s.vatValue))]), " ", _h('td', {
      staticClass: "number"
    }, [_s(money(s.bruttoValue))])])
  })])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/InvoiceSummary.vue
 ** module id = 171
 ** module chunks = 2
 **/